export default __webpack_public_path__ + "static/media/user.7c2b1c51.svg";